import * as z from 'zod';
import type { AuthProviderProps } from 'react-oidc-context';

export const clientId = z
  .string()
  .nonempty()
  .parse(import.meta.env.APP_CLIENT_WEB_OIDC_CLIENT_ID);

export const logoutRedirectUri = new URL('', window.location.origin).toString();
export const redirectUri = new URL('', window.location.origin).toString();

export const authProviderConfig: AuthProviderProps = {
  authority: z.url().parse(import.meta.env.APP_CLIENT_WEB_OIDC_AUTHORITY),
  client_id: clientId,

  response_type: 'code',
  redirect_uri: redirectUri,
  scope:
    'aws.cognito.signin.user.admin data-collection/public-api email openid phone profile',
} as const;
